module.exports = [
	{
		"fund_id": "FSUSA00B4P",
		"investment_vehicle_id": "FEUSA0000F",
		"ticker": "IVW",
		"fund_legal_name": "iShares S&P 500 Growth ETF",
		"morningstar_category_name": "Large Growth",
		"fund_net_assets": 62454989912,
		"grade_fossil": 3,
		"grade_deforestation": 2,
		"grade_tobacco": 4,
		"grade_gender_equality": 4,
		"grade_dei": 1,
		"grade_rji": 3,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 2,
		"c2f5coogutweight": 0.039309859480858154,
		"cl_weight": 0.28813608086837944,
		"fossil_bank_score": 17.2812,
		"fossil_insure_score": 15.5485,
		"wff_mil_weight": 0.0347205419262138,
		"mmc_weight": 0.0347205419262138,
		"cm_weight": 0.007590224501251463,
		"nw_weight": 0.013727778125393738,
		"wff_civ_weight": 0.00974034202087736,
		"gm_weight": 0,
		"gr_weight": 0.00974034202087736,
		"t_all_weight": 0.006383352879985111,
		"to_weight": 0.006383352879985111,
		"tm_weight": 0,
		"po_producer_weight": 0,
		"po_financier_weight": 0.01883550231131279,
		"po_consumer_weight": 0.08235348140336966,
		"pp_weight": 0.22792042897283263,
		"borders_weight": 0.21332539205539913,
		"pp_high_weight": 0.004436170732925965,
		"borders_high_weight": 0.020491434946940473,
		"pff_all_weight": 0.2524878133892799,
		"pff_all_high_weight": 0.020491434946940473,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 53.406892907568924,
		"gef_score_a": 25.181472925851903,
		"gef_score_b": 9.42590606005549,
		"gef_score_c": 18.167979914353648,
		"gef_score_d": 0.6315340072915381,
		"gef_score_a_norm": 62.95368231462975,
		"gef_score_b_norm": 31.419686866851638,
		"gef_score_c_norm": 90.83989957176823,
		"gef_score_d_norm": 6.31534007291538,
		"prospectus_net_expense_ratio": 0.18,
		"trailing_return_m1": 3.40954,
		"trailing_return_m3": 20.26821,
		"trailing_return_m6": 9.54313,
		"trailing_return_y1": 25.39088,
		"trailing_return_y3": 19.6442,
		"trailing_return_y5": 16.28871,
		"trailing_return_y10": 15.72508,
		"trailing_return_y15": 16.37151,
		"trailing_return_y20": 12.19695,
		"performance_as_of_date": "2025-07-31T00:00:00.000Z",
		"index_name": "S&P 500 Growth",
		"footprint": 22.882636213323696,
		"intensity": 71.94591785242196,
		"name": "IVW - iShares S&P 500 Growth ETF",
		"label": "IVW - iShares S&P 500 Growth ETF"
	},
	{
		"fund_id": "FSUSA00B4Q",
		"investment_vehicle_id": "FEUSA0000G",
		"ticker": "IVE",
		"fund_legal_name": "iShares S&P 500 Value ETF",
		"morningstar_category_name": "Large Value",
		"fund_net_assets": 39577059600,
		"grade_fossil": 5,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 1,
		"grade_dei": 2,
		"grade_rji": 2,
		"grade_hrc": 2,
		"grade_prison_industrial_complex": 4,
		"grade_military": 5,
		"grade_guns": 4,
		"c2f5coogutweight": 0.12556846991463647,
		"cl_weight": 0.22610700216383559,
		"fossil_bank_score": 47.1313,
		"fossil_insure_score": 26.5349,
		"wff_mil_weight": 0.040838612295187676,
		"mmc_weight": 0.040838612295187676,
		"cm_weight": 0.022755401864206364,
		"nw_weight": 0.037737818498926004,
		"wff_civ_weight": 0.00878521639599572,
		"gm_weight": 0.0031471453615044224,
		"gr_weight": 0.005638071034491298,
		"t_all_weight": 0.028910443315415736,
		"to_weight": 0.007012097482334724,
		"tm_weight": 0.021898345833081014,
		"po_producer_weight": 0.0034120427931507904,
		"po_financier_weight": 0.037758714637676744,
		"po_consumer_weight": 0.145006374751824,
		"pp_weight": 0.16549174385021267,
		"borders_weight": 0.16050894269464944,
		"pp_high_weight": 0.0017526940993237746,
		"borders_high_weight": 0.019343494545622193,
		"pff_all_weight": 0.2061210219191779,
		"pff_all_high_weight": 0.019343494545622193,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 56.31052010650121,
		"gef_score_a": 27.722373691970983,
		"gef_score_b": 9.229310868491979,
		"gef_score_c": 18.6203209659324,
		"gef_score_d": 0.7385145801066758,
		"gef_score_a_norm": 69.30593422992746,
		"gef_score_b_norm": 30.76436956163993,
		"gef_score_c_norm": 93.101604829662,
		"gef_score_d_norm": 7.385145801066758,
		"prospectus_net_expense_ratio": 0.18,
		"trailing_return_m1": 0.87202,
		"trailing_return_m3": 7.71469,
		"trailing_return_m6": 1.17989,
		"trailing_return_y1": 5.40459,
		"trailing_return_y3": 12.84642,
		"trailing_return_y5": 14.19424,
		"trailing_return_y10": 10.28125,
		"trailing_return_y15": 11.60913,
		"trailing_return_y20": 8.24335,
		"performance_as_of_date": "2025-07-31T00:00:00.000Z",
		"index_name": "S&P 500 Value",
		"footprint": 147.335576324996,
		"intensity": 220.5813107990886,
		"name": "IVE - iShares S&P 500 Value ETF",
		"label": "IVE - iShares S&P 500 Value ETF"
	},
	{
		"fund_id": "FSUSA00B5I",
		"investment_vehicle_id": "FEUSA00018",
		"ticker": "IWO",
		"fund_legal_name": "iShares Russell 2000 Growth ETF",
		"morningstar_category_name": "Small Growth",
		"fund_net_assets": 11689361048,
		"grade_fossil": 3,
		"grade_deforestation": 2,
		"grade_tobacco": 3,
		"grade_gender_equality": 5,
		"grade_dei": 5,
		"grade_rji": 5,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 3,
		"c2f5coogutweight": 0.027522256581550594,
		"cl_weight": 0,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"wff_mil_weight": 0.04238114944592633,
		"mmc_weight": 0.04238114944592633,
		"cm_weight": 0,
		"nw_weight": 0.016125177651701385,
		"wff_civ_weight": 0.00013968346276723389,
		"gm_weight": 0.00013968346276723389,
		"gr_weight": 0,
		"t_all_weight": 0.0009377231226682047,
		"to_weight": 0.0009377231226682047,
		"tm_weight": 0,
		"po_producer_weight": 0,
		"po_financier_weight": 0,
		"po_consumer_weight": 0.0014884630581165847,
		"pp_weight": 0.0075949343017138035,
		"borders_weight": 0.01534173643446412,
		"pp_high_weight": 0.003758813312038427,
		"borders_high_weight": 0.006293125706483513,
		"pff_all_weight": 0.01931754088690673,
		"pff_all_high_weight": 0.006432809169250747,
		"pff_all_extreme_weight": 0.0029127508120272193,
		"gef_score_norm": 36.10366797259448,
		"gef_score_a": 18.35718178527971,
		"gef_score_b": 3.199486675691325,
		"gef_score_c": 14.5423274949748,
		"gef_score_d": 0.004672016654831908,
		"gef_score_a_norm": 45.892954463199274,
		"gef_score_b_norm": 10.66495558563775,
		"gef_score_c_norm": 72.711637474874,
		"gef_score_d_norm": 0.04672016654831908,
		"prospectus_net_expense_ratio": 0.24,
		"trailing_return_m1": 1.69007,
		"trailing_return_m3": 14.5329,
		"trailing_return_m6": -1.94806,
		"trailing_return_y1": 3.0501,
		"trailing_return_y3": 9.01392,
		"trailing_return_y5": 6.97768,
		"trailing_return_y10": 7.25943,
		"trailing_return_y15": 10.72804,
		"trailing_return_y20": 8.21751,
		"performance_as_of_date": "2025-07-31T00:00:00.000Z",
		"index_name": "Russell 2000 Growth",
		"footprint": 138.53454201517556,
		"intensity": 156.10505164940264,
		"name": "IWO - iShares Russell 2000 Growth ETF",
		"label": "IWO - iShares Russell 2000 Growth ETF"
	},
	{
		"fund_id": "FSUSA00B5J",
		"investment_vehicle_id": "FEUSA00019",
		"ticker": "IWN",
		"fund_legal_name": "iShares Russell 2000 Value ETF",
		"morningstar_category_name": "Small Value",
		"fund_net_assets": 10813732196,
		"grade_fossil": 5,
		"grade_deforestation": 2,
		"grade_tobacco": 3,
		"grade_gender_equality": 4,
		"grade_dei": 5,
		"grade_rji": 4,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.11608270446152381,
		"cl_weight": 0.006651588411357387,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"wff_mil_weight": 0.030824392191249748,
		"mmc_weight": 0.030824392191249748,
		"cm_weight": 0.008058177320271117,
		"nw_weight": 0.008661722888533323,
		"wff_civ_weight": 0.0038565236738038002,
		"gm_weight": 0.0011459522883097786,
		"gr_weight": 0.0027105713854940214,
		"t_all_weight": 0.0022084719548318868,
		"to_weight": 0.001195401807801533,
		"tm_weight": 0.0010130701470303536,
		"po_producer_weight": 0,
		"po_financier_weight": 0,
		"po_consumer_weight": 0.005695978482258391,
		"pp_weight": 0.0020150142420596456,
		"borders_weight": 0.0055098027113813985,
		"pp_high_weight": 0.0019510199219658427,
		"borders_high_weight": 0.002122993467739688,
		"pff_all_weight": 0.005858111924802483,
		"pff_all_high_weight": 0.002407308361066969,
		"pff_all_extreme_weight": 0.0014728450016905387,
		"gef_score_norm": 39.437635399642645,
		"gef_score_a": 20.261511543286318,
		"gef_score_b": 3.5023517953491767,
		"gef_score_c": 15.609414326238054,
		"gef_score_d": 0.06435773477310819,
		"gef_score_a_norm": 50.653778858215794,
		"gef_score_b_norm": 11.674505984497257,
		"gef_score_c_norm": 78.04707163119026,
		"gef_score_d_norm": 0.6435773477310819,
		"prospectus_net_expense_ratio": 0.24,
		"trailing_return_m1": 1.73904,
		"trailing_return_m3": 11.21564,
		"trailing_return_m6": -3.52438,
		"trailing_return_y1": -4.44541,
		"trailing_return_y3": 4.57059,
		"trailing_return_y5": 12.15976,
		"trailing_return_y10": 7.02847,
		"trailing_return_y15": 8.81029,
		"trailing_return_y20": 6.44379,
		"performance_as_of_date": "2025-07-31T00:00:00.000Z",
		"index_name": "Russell 2000 Value",
		"footprint": 210.67117372007064,
		"intensity": 146.1275380116073,
		"name": "IWN - iShares Russell 2000 Value ETF",
		"label": "IWN - iShares Russell 2000 Value ETF"
	},
	{
		"fund_id": "FSUSA00B5L",
		"investment_vehicle_id": "FEUSA0001B",
		"ticker": "IWF",
		"fund_legal_name": "iShares Russell 1000 Growth ETF",
		"morningstar_category_name": "Large Growth",
		"fund_net_assets": 115281767200,
		"grade_fossil": 3,
		"grade_deforestation": 2,
		"grade_tobacco": 1,
		"grade_gender_equality": 4,
		"grade_dei": 2,
		"grade_rji": 1,
		"grade_hrc": 2,
		"grade_prison_industrial_complex": 4,
		"grade_military": 3,
		"grade_guns": 2,
		"c2f5coogutweight": 0.018559456387893504,
		"cl_weight": 0.3729366484726385,
		"fossil_bank_score": 1.7136,
		"fossil_insure_score": 0.0646,
		"wff_mil_weight": 0.020957977896977873,
		"mmc_weight": 0.020957977896977873,
		"cm_weight": 0.001305164688035519,
		"nw_weight": 0.012748465537702711,
		"wff_civ_weight": 0.001390521572490369,
		"gm_weight": 0,
		"gr_weight": 0.001390521572490369,
		"t_all_weight": 0,
		"to_weight": 0,
		"tm_weight": 0,
		"po_producer_weight": 0,
		"po_financier_weight": 0.0018505783830285354,
		"po_consumer_weight": 0.08818154015046967,
		"pp_weight": 0.24524809307678,
		"borders_weight": 0.24150310556778992,
		"pp_high_weight": 0.002845453517192313,
		"borders_high_weight": 0.015390711314176637,
		"pff_all_weight": 0.2588434762116746,
		"pff_all_high_weight": 0.015390711314176637,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 53.377560200987574,
		"gef_score_a": 24.771357692283463,
		"gef_score_b": 9.788221229723321,
		"gef_score_c": 18.11165238748441,
		"gef_score_d": 0.7063288914896952,
		"gef_score_a_norm": 61.92839423070866,
		"gef_score_b_norm": 32.62740409907774,
		"gef_score_c_norm": 90.55826193742205,
		"gef_score_d_norm": 7.063288914896952,
		"prospectus_net_expense_ratio": 0.19,
		"trailing_return_m1": 3.76039,
		"trailing_return_m3": 20.10113,
		"trailing_return_m6": 7.86449,
		"trailing_return_y1": 23.52379,
		"trailing_return_y3": 22.39845,
		"trailing_return_y5": 17.07348,
		"trailing_return_y10": 16.84653,
		"trailing_return_y15": 17.0699,
		"trailing_return_y20": 12.72779,
		"performance_as_of_date": "2025-07-31T00:00:00.000Z",
		"index_name": "Russell 1000 Growth",
		"footprint": 27.104039919030285,
		"intensity": 72.28267458266703,
		"name": "IWF - iShares Russell 1000 Growth ETF",
		"label": "IWF - iShares Russell 1000 Growth ETF"
	},
	{
		"fund_id": "FSUSA00B5M",
		"investment_vehicle_id": "FEUSA0001C",
		"ticker": "IWD",
		"fund_legal_name": "iShares Russell 1000 Value ETF",
		"morningstar_category_name": "Large Value",
		"fund_net_assets": 61645044685,
		"grade_fossil": 5,
		"grade_deforestation": 3,
		"grade_tobacco": 5,
		"grade_gender_equality": 3,
		"grade_dei": 4,
		"grade_rji": 5,
		"grade_hrc": 4,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 4,
		"c2f5coogutweight": 0.14202512325854216,
		"cl_weight": 0.09033713656580329,
		"fossil_bank_score": 57.8904,
		"fossil_insure_score": 39.8941,
		"wff_mil_weight": 0.0596855501502399,
		"mmc_weight": 0.0596855501502399,
		"cm_weight": 0.028870035684483975,
		"nw_weight": 0.03822590773192506,
		"wff_civ_weight": 0.016969274783467252,
		"gm_weight": 0.0028695748065313818,
		"gr_weight": 0.01409969997693587,
		"t_all_weight": 0.032064611113382116,
		"to_weight": 0.012845194239664449,
		"tm_weight": 0.019219416873717674,
		"po_producer_weight": 0.002985147793983516,
		"po_financier_weight": 0.050932283718154836,
		"po_consumer_weight": 0.12117073400997355,
		"pp_weight": 0.11870589010435215,
		"borders_weight": 0.10436877318171522,
		"pp_high_weight": 0.0034646304763711524,
		"borders_high_weight": 0.023773179963096597,
		"pff_all_weight": 0.16767664915110805,
		"pff_all_high_weight": 0.023773179963096597,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 53.95590330730271,
		"gef_score_a": 27.21996826577374,
		"gef_score_b": 8.006869837830186,
		"gef_score_c": 18.173466784503965,
		"gef_score_d": 0.5555984191854325,
		"gef_score_a_norm": 68.04992066443435,
		"gef_score_b_norm": 26.689566126100615,
		"gef_score_c_norm": 90.86733392251982,
		"gef_score_d_norm": 5.555984191854326,
		"prospectus_net_expense_ratio": 0.19,
		"trailing_return_m1": 0.55973,
		"trailing_return_m3": 7.61594,
		"trailing_return_m6": 1.80736,
		"trailing_return_y1": 8.59527,
		"trailing_return_y3": 10.39662,
		"trailing_return_y5": 12.97916,
		"trailing_return_y10": 9.01778,
		"trailing_return_y15": 10.92892,
		"trailing_return_y20": 7.8163,
		"performance_as_of_date": "2025-07-31T00:00:00.000Z",
		"index_name": "Russell 1000 Value",
		"footprint": 163.94657295457372,
		"intensity": 244.40950089263998,
		"name": "IWD - iShares Russell 1000 Value ETF",
		"label": "IWD - iShares Russell 1000 Value ETF"
	},
	{
		"fund_id": "FSUSA00B6U",
		"investment_vehicle_id": "FEUSA0002J",
		"ticker": "OEF",
		"fund_legal_name": "iShares S&P 100 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 21380460601,
		"grade_fossil": 3,
		"grade_deforestation": 2,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": 1,
		"grade_rji": 1,
		"grade_hrc": 1,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_guns": 2,
		"c2f5coogutweight": 0.05456651898188278,
		"cl_weight": 0.3398010282756788,
		"fossil_bank_score": 42.3121,
		"fossil_insure_score": 23.4385,
		"wff_mil_weight": 0.030690353817887504,
		"mmc_weight": 0.030690353817887504,
		"cm_weight": 0.013495828559837062,
		"nw_weight": 0.025342484709698312,
		"wff_civ_weight": 0.010989243191302282,
		"gm_weight": 0,
		"gr_weight": 0.010989243191302282,
		"t_all_weight": 0.02322862524282101,
		"to_weight": 0.009337158635256746,
		"tm_weight": 0.013891466607564264,
		"po_producer_weight": 0,
		"po_financier_weight": 0.03852037757851186,
		"po_consumer_weight": 0.13602324930795243,
		"pp_weight": 0.26729345591651354,
		"borders_weight": 0.2531952145538422,
		"pp_high_weight": 0,
		"borders_high_weight": 0.018529698035780272,
		"pff_all_weight": 0.3063015655042874,
		"pff_all_high_weight": 0.018529698035780272,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 55.8272646415237,
		"gef_score_a": 26.367839997769973,
		"gef_score_b": 10.26189786004262,
		"gef_score_c": 18.339807635761062,
		"gef_score_d": 0.8577191479408991,
		"gef_score_a_norm": 65.91959999442494,
		"gef_score_b_norm": 34.206326200142065,
		"gef_score_c_norm": 91.69903817880531,
		"gef_score_d_norm": 8.577191479408992,
		"prospectus_net_expense_ratio": 0.2,
		"trailing_return_m1": 2.87292,
		"trailing_return_m3": 16.49071,
		"trailing_return_m6": 6.65545,
		"trailing_return_y1": 19.07579,
		"trailing_return_y3": 19.88726,
		"trailing_return_y5": 17.24557,
		"trailing_return_y10": 14.73676,
		"trailing_return_y15": 15.01842,
		"trailing_return_y20": 10.93966,
		"performance_as_of_date": "2025-07-31T00:00:00.000Z",
		"index_name": "S&P 100",
		"footprint": 50.295241468364594,
		"intensity": 120.77831715622968,
		"name": "OEF - iShares S&P 100 ETF",
		"label": "OEF - iShares S&P 100 ETF"
	},
	{
		"fund_id": "FSUSA04YKB",
		"investment_vehicle_id": "FEUSA04ACN",
		"ticker": "ILCB",
		"fund_legal_name": "iShares Morningstar U.S. Equity ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 1083577997,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 3,
		"grade_dei": 2,
		"grade_rji": 3,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.07719803779205164,
		"cl_weight": 0.25109095068035997,
		"fossil_bank_score": 30.2069,
		"fossil_insure_score": 19.8637,
		"wff_mil_weight": 0.0380810213331665,
		"mmc_weight": 0.0380810213331665,
		"cm_weight": 0.014839936449940286,
		"nw_weight": 0.024793641736953146,
		"wff_civ_weight": 0.00906670737446446,
		"gm_weight": 0.0014896664586208411,
		"gr_weight": 0.007577040915843618,
		"t_all_weight": 0.015968486070197324,
		"to_weight": 0.006412531435518673,
		"tm_weight": 0.009555954634678652,
		"po_producer_weight": 0.0012773599309105915,
		"po_financier_weight": 0.02685314726855732,
		"po_consumer_weight": 0.10799245643396939,
		"pp_weight": 0.1943124750275105,
		"borders_weight": 0.18502682562564285,
		"pp_high_weight": 0.0030717806103419897,
		"borders_high_weight": 0.01963870275927601,
		"pff_all_weight": 0.22563813967447333,
		"pff_all_high_weight": 0.01963870275927601,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 54.22136763565653,
		"gef_score_a": 26.122746827648637,
		"gef_score_b": 9.184679005282476,
		"gef_score_c": 18.25506163716423,
		"gef_score_d": 0.6588801655528482,
		"gef_score_a_norm": 65.3068670691216,
		"gef_score_b_norm": 30.61559668427492,
		"gef_score_c_norm": 91.27530818582115,
		"gef_score_d_norm": 6.588801655528482,
		"prospectus_net_expense_ratio": 0.03,
		"trailing_return_m1": 2.28046,
		"trailing_return_m3": 14.47357,
		"trailing_return_m6": 5.52453,
		"trailing_return_y1": 16.86957,
		"trailing_return_y3": 17.28081,
		"trailing_return_y5": 14.913,
		"trailing_return_y10": 13.05532,
		"trailing_return_y15": 14.23081,
		"trailing_return_y20": 10.82861,
		"performance_as_of_date": "2025-07-31T00:00:00.000Z",
		"index_name": "Morningstar U.S. Equity",
		"footprint": 92.78032831872646,
		"intensity": 180.94636729905469,
		"name": "ILCB - iShares Morningstar U.S. Equity ETF",
		"label": "ILCB - iShares Morningstar U.S. Equity ETF"
	},
	{
		"fund_id": "FSUSA04YKE",
		"investment_vehicle_id": "FEUSA04ACQ",
		"ticker": "IMCB",
		"fund_legal_name": "iShares Morningstar Mid-Cap ETF",
		"morningstar_category_name": "Mid-Cap Blend",
		"fund_net_assets": 1140415062,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 1,
		"grade_gender_equality": 1,
		"grade_dei": 1,
		"grade_rji": 1,
		"grade_hrc": 2,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 1,
		"c2f5coogutweight": 0.1407572795227016,
		"cl_weight": 0.04609338098687387,
		"fossil_bank_score": 4.4124,
		"fossil_insure_score": 13.5733,
		"wff_mil_weight": 0.03015542951502757,
		"mmc_weight": 0.03015542951502757,
		"cm_weight": 0.0072946587146013745,
		"nw_weight": 0.01582353598421917,
		"wff_civ_weight": 0,
		"gm_weight": 0,
		"gr_weight": 0,
		"t_all_weight": 0,
		"to_weight": 0,
		"tm_weight": 0,
		"po_producer_weight": 0.0061567288691093715,
		"po_financier_weight": 0,
		"po_consumer_weight": 0.05168327468733035,
		"pp_weight": 0.03439903746431637,
		"borders_weight": 0.032597259370244,
		"pp_high_weight": 0.008503112631884486,
		"borders_high_weight": 0.020280825319293056,
		"pff_all_weight": 0.05031426630376158,
		"pff_all_high_weight": 0.020280825319293056,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 50.03100414606849,
		"gef_score_a": 25.55689717487212,
		"gef_score_b": 6.533330469798175,
		"gef_score_c": 17.785963918844978,
		"gef_score_d": 0.15481258254506294,
		"gef_score_a_norm": 63.8922429371803,
		"gef_score_b_norm": 21.777768232660584,
		"gef_score_c_norm": 88.9298195942249,
		"gef_score_d_norm": 1.5481258254506294,
		"prospectus_net_expense_ratio": 0.04,
		"trailing_return_m1": 1.63567,
		"trailing_return_m3": 11.21289,
		"trailing_return_m6": 2.70424,
		"trailing_return_y1": 12.63548,
		"trailing_return_y3": 11.25947,
		"trailing_return_y5": 12.13898,
		"trailing_return_y10": 9.50085,
		"trailing_return_y15": 12.26252,
		"trailing_return_y20": 9.3918,
		"performance_as_of_date": "2025-07-31T00:00:00.000Z",
		"index_name": "Morningstar Mid-Cap",
		"footprint": 211.17432119436003,
		"intensity": 276.1060472580773,
		"name": "IMCB - iShares Morningstar Mid-Cap ETF",
		"label": "IMCB - iShares Morningstar Mid-Cap ETF"
	},
	{
		"fund_id": "FSUSA04YKH",
		"investment_vehicle_id": "FEUSA04ACT",
		"ticker": "ISCB",
		"fund_legal_name": "iShares Morningstar Small-Cap ETF",
		"morningstar_category_name": "Small Blend",
		"fund_net_assets": 234744193,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 3,
		"grade_gender_equality": 4,
		"grade_dei": 3,
		"grade_rji": 3,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 3,
		"c2f5coogutweight": 0.063696582828879,
		"cl_weight": 0.008474870295424633,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0.9373,
		"wff_mil_weight": 0.048311809293474534,
		"mmc_weight": 0.048311809293474534,
		"cm_weight": 0.0038879516266265434,
		"nw_weight": 0.017571445648624864,
		"wff_civ_weight": 0.003484292151544958,
		"gm_weight": 0.0005181469935069404,
		"gr_weight": 0.0029661451580380175,
		"t_all_weight": 0.0022594672033767475,
		"to_weight": 0.0004883648678445349,
		"tm_weight": 0.001771102335532213,
		"po_producer_weight": 0.0020865364032836785,
		"po_financier_weight": 0,
		"po_consumer_weight": 0.011202189471140482,
		"pp_weight": 0.010425340514383848,
		"borders_weight": 0.016257970683407945,
		"pp_high_weight": 0.0036053101674423374,
		"borders_high_weight": 0.006493322891161289,
		"pff_all_weight": 0.01851196466751197,
		"pff_all_high_weight": 0.006602689616380362,
		"pff_all_extreme_weight": 0.001105721922101704,
		"gef_score_norm": 40.86601712195396,
		"gef_score_a": 20.970656958743515,
		"gef_score_b": 4.086399310118901,
		"gef_score_c": 15.740146555368845,
		"gef_score_d": 0.06881429772396225,
		"gef_score_a_norm": 52.42664239685879,
		"gef_score_b_norm": 13.621331033729673,
		"gef_score_c_norm": 78.70073277684423,
		"gef_score_d_norm": 0.6881429772396225,
		"prospectus_net_expense_ratio": 0.04,
		"trailing_return_m1": 2.04765,
		"trailing_return_m3": 12.44846,
		"trailing_return_m6": -1.99249,
		"trailing_return_y1": 3.46185,
		"trailing_return_y3": 8.34003,
		"trailing_return_y5": 10.37741,
		"trailing_return_y10": 6.96926,
		"trailing_return_y15": 9.5735,
		"trailing_return_y20": 7.50364,
		"performance_as_of_date": "2025-07-31T00:00:00.000Z",
		"index_name": "Morningstar Small-Cap",
		"footprint": 153.85328193312995,
		"intensity": 146.31857820609906,
		"name": "ISCB - iShares Morningstar Small-Cap ETF",
		"label": "ISCB - iShares Morningstar Small-Cap ETF"
	},
	{
		"fund_id": "FSUSA06EC6",
		"investment_vehicle_id": "FEUSA04ADS",
		"ticker": "IWC",
		"fund_legal_name": "iShares Micro-Cap ETF",
		"morningstar_category_name": "Small Blend",
		"fund_net_assets": 834558215,
		"grade_fossil": 3,
		"grade_deforestation": 1,
		"grade_tobacco": 3,
		"grade_gender_equality": -1,
		"grade_dei": 5,
		"grade_rji": 5,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 3,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.03461228617718777,
		"cl_weight": 0,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"wff_mil_weight": 0.029385394051602124,
		"mmc_weight": 0.029385394051602124,
		"cm_weight": 0.0013668760245615433,
		"nw_weight": 0.0034141004648133998,
		"wff_civ_weight": 0.003240816474188545,
		"gm_weight": 0.002890782932669638,
		"gr_weight": 0.0003500335415189069,
		"t_all_weight": 0.0038625563961507026,
		"to_weight": 0.0038625563961507026,
		"tm_weight": 0,
		"po_producer_weight": 0,
		"po_financier_weight": 0,
		"po_consumer_weight": 0,
		"pp_weight": 0.002778680007590569,
		"borders_weight": 0.0026262228507049176,
		"pp_high_weight": 0.0025496864482643967,
		"borders_high_weight": 0.0025496864482643967,
		"pff_all_weight": 0.00285521641003109,
		"pff_all_high_weight": 0.0025496864482643967,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 27.93674745970102,
		"gef_score_a": 14.67520054419258,
		"gef_score_b": 5.124546150249276,
		"gef_score_c": 8.13700076525917,
		"gef_score_d": 0,
		"gef_score_a_norm": 36.68800136048145,
		"gef_score_b_norm": 17.08182050083092,
		"gef_score_c_norm": 40.685003826295855,
		"gef_score_d_norm": 0,
		"prospectus_net_expense_ratio": 0.6,
		"trailing_return_m1": 2.06689,
		"trailing_return_m3": 18.36009,
		"trailing_return_m6": 0.68006,
		"trailing_return_y1": 3.23439,
		"trailing_return_y3": 5.7108,
		"trailing_return_y5": 9.25665,
		"trailing_return_y10": 6.43196,
		"trailing_return_y15": 9.28537,
		"trailing_return_y20": -1000,
		"performance_as_of_date": "2025-07-31T00:00:00.000Z",
		"index_name": "Russell Microcap",
		"footprint": 243.54934065647353,
		"intensity": 169.31538594444189,
		"name": "IWC - iShares Micro-Cap ETF",
		"label": "IWC - iShares Micro-Cap ETF"
	},
	{
		"fund_id": "FSUSA0A2N9",
		"investment_vehicle_id": "F000003WKP",
		"ticker": "IWL",
		"fund_legal_name": "iShares Russell Top 200 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 1771489523,
		"grade_fossil": 4,
		"grade_deforestation": 2,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": 1,
		"grade_rji": 2,
		"grade_hrc": 2,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.06618873620275793,
		"cl_weight": 0.29378482842610604,
		"fossil_bank_score": 36.1123,
		"fossil_insure_score": 22.6086,
		"wff_mil_weight": 0.03875774428590345,
		"mmc_weight": 0.03875774428590345,
		"cm_weight": 0.016217597316830035,
		"nw_weight": 0.026273419465463913,
		"wff_civ_weight": 0.010872893378859957,
		"gm_weight": 0.0016852407025020866,
		"gr_weight": 0.00918765267635787,
		"t_all_weight": 0.01920674074000151,
		"to_weight": 0.007760859117674148,
		"tm_weight": 0.011445881622327365,
		"po_producer_weight": 0,
		"po_financier_weight": 0.03199880513756995,
		"po_consumer_weight": 0.11885109220569873,
		"pp_weight": 0.22574591008943914,
		"borders_weight": 0.21413051923601506,
		"pp_high_weight": 0.001578250340253296,
		"borders_high_weight": 0.018854969986869596,
		"pff_all_weight": 0.25977529895069246,
		"pff_all_high_weight": 0.018854969986869596,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 55.15876329672081,
		"gef_score_a": 26.286924649875406,
		"gef_score_b": 9.742770831154742,
		"gef_score_c": 18.368527643677474,
		"gef_score_d": 0.7605401720053054,
		"gef_score_a_norm": 65.7173116246885,
		"gef_score_b_norm": 32.47590277051581,
		"gef_score_c_norm": 91.84263821838738,
		"gef_score_d_norm": 7.605401720053054,
		"prospectus_net_expense_ratio": 0.15,
		"trailing_return_m1": 2.30461,
		"trailing_return_m3": 14.91325,
		"trailing_return_m6": 5.80238,
		"trailing_return_y1": 17.62975,
		"trailing_return_y3": 18.52565,
		"trailing_return_y5": 16.36485,
		"trailing_return_y10": 14.40634,
		"trailing_return_y15": 14.96897,
		"trailing_return_y20": -1000,
		"performance_as_of_date": "2025-07-31T00:00:00.000Z",
		"index_name": "Russell Top 200",
		"footprint": 60.02532538962697,
		"intensity": 132.94129555375534,
		"name": "IWL - iShares Russell Top 200 ETF",
		"label": "IWL - iShares Russell Top 200 ETF"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/ExtendedBenchmarks.json
// module id = 948
// module chunks = 0